import React from 'react';
import InputValidator from '../common/InputValidator.jsx';
import validatedComponent from '../common/ValidatedComponent.jsx';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as Actions from './redux/actions.forgotPw';

class ForgotPasswordRequest extends React.Component {
  constructor() {
    super();

    this.state = {
      email: ''
    };
  }

  componentDidMount() {
    this.props.initForgotPw();
  }

  onChange(e) {
    this.setState({email: e.target.value});
  }

  onResetClick(e) {
    e.preventDefault();

    if (this.context.isComponentValid()) {
      this.props.requestForgotPw(this.state.email);
    }
  }

  render() {
    const {email} = this.state;
    const {isSent, errors} = this.props;
    return (
      <div className="ba-forgot-password panel">
        <div className="row">
          <div className="large-12 end columns">
            <h2>Reset password</h2>
          </div>
        </div>
        {!isSent ?
          <form noValidate>
            <div className="row">
              <div className="large-12 columns">
                <InputValidator fieldName="Email"
                                errors={errors.email}>
                  <input type="email"
                         required
                         placeholder="Forgot Password Email*"
                         value={email}
                         onChange={e => this.setState({email: e.target.value})}/>
                </InputValidator>
              </div>
            </div>
            <div className="row">
              <div className="large-12 columns">
                <button onClick={this.onResetClick.bind(this)}>
                  Send reset password email
                </button>
              </div>
            </div>
          </form>
          :
          <div className="row">
            <div className="large-12 end columns">
              <p>Reset password email has been sent to <b>{email}</b>.
                Please follow the instructions from the email.</p>
            </div>
          </div>
        }
      </div>);
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {...state.forgotPw};
}

ForgotPasswordRequest.displayName = 'ForgotPasswordRequest';

export default connect(mapStateToProps, mapDispatchToProps)(validatedComponent(ForgotPasswordRequest));




// WEBPACK FOOTER //
// ./shared/auth/ForgotPasswordRequest.jsx